import { func, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Button from '../../../components/Button';
import { TextButton } from '../../../styles-and-themes/styles/styled';
import { getIdTokenIfValid } from '../../../utils/jwt-utils';
import {
  EmailsOuterContainer,
  EmailsInnerContainer,
  EmailLabel,
  EmailData,
  ChangeDesc,
  ChangeDescBold,
  ModalInfoMessage,
  ModalContentContainer,
  ModalInfoDescription,
  ModalInfoDescriptionBold,
} from './EmailChangePendingPanelStyles';
import Modal from '../../../components/Modal';

const EmailChangePendingPanel = ({
  onContinue,
  currentEmail,
  newEmail,
}) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [userId] = useState(() => getIdTokenIfValid()?.user_id);

  useEffect(() => {
    if (!showReject) return;
    axios.delete(`/api/v2/fi/users/${userId}/contacts/email`)
      .then((response) => {
        if (response.status !== 204) {
          console.log(`error rejecting email, response:${response.status}`);
        }
      })
      .catch((err) => console.log('error rejecting email', err));
  },
  [showReject]);

  useEffect(() => {
    if (!showConfirm) return;
    axios.post(`/api/v2/fi/users/${userId}/emails`, { templateName: 'email-change-choice-validate' })
      .then((response) => {
        if (response.status !== 204) {
          console.log(`error resending email, response:${response.status}`);
        }
      })
      .catch((err) => console.log('error resending email', err));
  },
  [showConfirm]);

  return (
    <>
      {
        showConfirm && (
          <Modal
            suppressHeader
            onCancel={() => { }}
            cancelDeactivatesModal={false}
            initialFocus="#confirmEmailContinue"
            footerContent={(
              <>
                <Button primary id="confirmEmailContinue" title="OK" onClick={onContinue} />
              </>
            )}
          >
            <ModalContentContainer>
              <ModalInfoMessage>
                Check Your Email to Confirm the Update
              </ModalInfoMessage>

              <ModalInfoDescription>
                A confirmation message has been sent to {newEmail}.
              </ModalInfoDescription>

              <ModalInfoDescription>
                Please check your inbox and use the link in that message to confirm the update to your username/email address and verify access to your new email account.
              </ModalInfoDescription>

              <ModalInfoDescription>
                <ModalInfoDescriptionBold>Tip:</ModalInfoDescriptionBold> If you don’t see the message, be sure to check your spam or junk folder.
              </ModalInfoDescription>
            </ModalContentContainer>
          </Modal>
        )
      }

      {
        showReject && (
          <Modal
            suppressHeader
            onCancel={() => { }}
            cancelDeactivatesModal={false}
            initialFocus="#rejectEmailContinue"
            footerContent={(
              <>
                <Button primary id="rejectEmailContinue" title="OK" onClick={onContinue} />
              </>
            )}
          >
            <ModalContentContainer>
              <ModalInfoMessage>
                Email Address Update Cancelled
              </ModalInfoMessage>
              <ModalInfoDescription>
                The request to update your username/email address has been cancelled.
              </ModalInfoDescription>
              <ModalInfoDescription>
                You can continue signing in with your current email address and password.
              </ModalInfoDescription>
            </ModalContentContainer>
          </Modal>
        )
      }

      <div>
        <h2>A request was made to update your username/email address:</h2>

        <EmailsOuterContainer>
          <EmailsInnerContainer>
            <EmailLabel>Current email:</EmailLabel>
            <EmailData>{currentEmail}</EmailData>
            <EmailLabel>Requested new email:</EmailLabel>
            <EmailData>{newEmail}</EmailData>
          </EmailsInnerContainer>
        </EmailsOuterContainer>

        <ChangeDesc>
          To confirm this change, please follow the instructions sent to your{' '}
          <ChangeDescBold>new email address.</ChangeDescBold>{' '}
          This will also become the address where you receive all future communications from us.
        </ChangeDesc>

        <ChangeDesc>
          Note: Your password will not be changed.
        </ChangeDesc>

        <div className="actionButtons">
          <Button
            title="Continue"
            id="continue"
            name="continue"
            primary
            onClick={() => setShowConfirm(true)}
          />
          <TextButton
            id="reject"
            name="reject"
            onClick={() => setShowReject(true)}
            className="cdlBtn secondary"
          >
            No, do not update my username/email address
          </TextButton>

        </div>
      </div>
    </>
  );
};

EmailChangePendingPanel.propTypes = {
  onContinue: func.isRequired,
  onReject: func.isRequired,
  currentEmail: string.isRequired,
  newEmail: string.isRequired,
};

export default EmailChangePendingPanel;
